import _ from 'lodash';
import React, { Component } from 'react';
import { MOBILE_WRAPPER_ID, ADD_MOBILE_ELEMENTS_FIRST_STEP, ADD_MOBILE_ELEMENTS_SECOND_STEP, ADD_MOBILE_ELEMENTS_THIRD_STEP } from 'crazyEditor/core/constants/editorConstants';
import { connect } from 'react-redux';
import MobileRenderer from './MobileRenderer';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { updateMobileViewSuccess } from 'crazyEditor/redux/modules/editor/editor';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { convertToMobileStructure } from 'crazyEditor/core/elements/dataConversation/mobileConversation';
import {
  getVisibleMobileElementsForRenderWithDragPosition, getNormalizedStaticDesktopElements,
  getNormalizedDesktopElementsForRender, getStaticMobileElements, getMobileElements, getVisibleMobileElementsForRender
} from 'crazyEditor/redux/modules/element/elementSelectors';
import { addMobileElementsFirstStep, addMobileElementsSecondStep, addMobileElementsThirdStep, resizeMobileElements } from 'crazyEditor/redux/modules/element/actions/mobileElementActions';
import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { getMobileDOMNodeById } from 'crazyEditor/core/elements/utils/elementRefUtils';

import sharedStyles from '../SharedViewStyles';
import styles from './MobileViewStyles';

@connect(
  (state, {isVisible}) => {
    return ({
      isMobileView: state.editor.isMobileView,
      mobileOverflow: state.editor.mobileOverflow,
      isWhiteLabel: state.user.isWhiteLabel,
      shouldUpdateMobileView: state.editor.shouldUpdateMobileView,
      desktopElements: getNormalizedDesktopElementsForRender(state),
      staticDesktopElements: getNormalizedStaticDesktopElements(state),
      mobileElements: getMobileElements(state),
      mobileVisibleElements: isVisible ? getVisibleMobileElementsForRenderWithDragPosition(state) : getVisibleMobileElementsForRender(state), // optimization, prevent processing drag position when not editing mobile.
      staticMobileElements: getStaticMobileElements(state),
      isDraggingElement: state.stage.isDraggingElement,
      addMobileElementsStep: state.element.present.addMobileElementsStep,
      autoHeightTextElement: state.user.autoHeightTextElement,
      isQuickPreviewMode: state.editor.isQuickPreviewMode,
    });
  }, {
    addMobileElementsFirstStep,
    addMobileElementsSecondStep,
    addMobileElementsThirdStep,
    resizeMobileElements,
    updateMobileViewSuccess
  }
)
@Radium
export default class MobileView extends Component {
  componentWillReceiveProps(nextProps) {
    const { updateMobileViewSuccess } = this.props;
    if (nextProps.isMobileView && nextProps.isPreviewMode) {
      document.querySelector('html').style.overflowY = 'hidden';
    } else {
      document.querySelector('html').style.overflowY = 'scroll';
    }

    if (nextProps.shouldUpdateMobileView) {
      this.updateMobileView();
      updateMobileViewSuccess();
    }
  }

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps)
      && (this.props.isVisible || nextProps.isVisible || nextProps.shouldUpdateMobileView || this.props.shouldUpdateMobileView || this.props.addMobileElementsStep !== nextProps.addMobileElementsStep);
  }

  componentDidUpdate(prevProps) {
    const { mobileVisibleElements, isDraggingElement, isMobileView, resizeMobileElements, addMobileElementsStep, addMobileElementsSecondStep, addMobileElementsThirdStep } = this.props;
    const prevMeasuredSizes = this.measuredSizes;
    if (!isDraggingElement && prevProps.mobileVisibleElements !== mobileVisibleElements) {
      const measuredSizes =
        _.filter(mobileVisibleElements, (element) => getElementDefinitionProps(element).autoHeight)
          .map((element) => {
            const elementDOMNode = getMobileDOMNodeById(element.id);
            if (elementDOMNode) {
              return {
                id: element.id,
                layout: {
                  height: elementDOMNode.offsetHeight,
                }
              };
            }
          });
      if ((!(_.isEmpty(prevMeasuredSizes) && _.isEmpty(measuredSizes))) && !_.isEqual(prevMeasuredSizes, measuredSizes)) {
        _.defer(resizeMobileElements);
        this.measuredSizes = measuredSizes;
      }
    }

    if (isMobileView && !prevProps.isMobileView) {
      _.defer(resizeMobileElements);
    }

    if (addMobileElementsStep === ADD_MOBILE_ELEMENTS_SECOND_STEP && prevProps.addMobileElementsStep === ADD_MOBILE_ELEMENTS_FIRST_STEP) {
      _.defer(addMobileElementsSecondStep);
    }

    if (addMobileElementsStep === ADD_MOBILE_ELEMENTS_THIRD_STEP && prevProps.addMobileElementsStep === ADD_MOBILE_ELEMENTS_SECOND_STEP) {
      _.defer(addMobileElementsThirdStep);
    }
  }

  componentWillUnmount() {
    document.querySelector('html').style.overflowY = '';
  }

  getContainerStyles() {
    const { isVisible } = this.props;
    return [
      isVisible && sharedStyles.visible,
      !isVisible && sharedStyles.hidden
    ];
  }

  getWrapperStyles() {
    const { isPreviewMode } = this.props;
    return [
      sharedStyles.templateWrapper,
      isPreviewMode && styles.previewMode.templateWrapper
    ];
  }

  getViewStyles() {
    const { mobileOverflow, isPreviewMode } = this.props;
    const defaultViewStyles = isPreviewMode ? styles.previewMode.mobileView : styles.mobileView;

    return _.assign({}, defaultViewStyles, {
      overflow: isPreviewMode || !mobileOverflow ? 'hidden' : 'visible'
    });
  }

  shouldShowAds() {
    const { isMobileView, isWhiteLabel, isPreviewMode } = this.props;
    return isMobileView && isPreviewMode && !isWhiteLabel;
  }

  updateMobileView() {
    if (this.shouldRunFirstTimeMobileConversation()) {
      this.runFirstTimeMobileConversation();
    } else if (this.shouldRunDeltaMobileConversation()) {
      this.runDeltaMobileConversation();
    }
  }

  shouldRunFirstTimeMobileConversation() {
    return !_.size(this.props.mobileElements) && _.size(this.props.desktopElements) > 0;
  }

  shouldRunDeltaMobileConversation() {
    return _.size(this.props.mobileElements) !== _.size(this.props.desktopElements);
  }

  runFirstTimeMobileConversation() {
    const { addMobileElementsFirstStep, desktopElements } = this.props;
    addMobileElementsFirstStep(convertToMobileStructure(desktopElements));
  }

  runDeltaMobileConversation() {
    const { mobileElements, desktopElements, addMobileElementsFirstStep } = this.props;
    const elementsToAdd = [];
    _.forEach(desktopElements, (desktopElement) => {
      if (!_.find(mobileElements, {desktopId: desktopElement.id})) {
        elementsToAdd.push(desktopElement);
      }
    });

    if (elementsToAdd.length) {
      const newMobileElements = convertToMobileStructure(elementsToAdd);
      addMobileElementsFirstStep(newMobileElements);
    }
  }

  render() {
    const {
      isPreviewMode,
      mobileVisibleElements,
      staticMobileElements,
      desktopElements,
      staticDesktopElements,
      isQuickPreviewMode,
    } = this.props;

    return (
      <div style={this.getContainerStyles()} id="mobile-view-frame">
        {isPreviewMode &&
        <div style={[styles.mobileFrame, {marginLeft: -6}]} id="mobile-view-frame-wrapper">
          <div style={styles.phoneTop} id="mobile-view-frame-top"></div>
          <div style={styles.phoneBG} id="mobile-view-frame-bg"></div>
          <div style={styles.phoneBottom} id="mobile-view-frame-bottom"></div>
        </div>
        }
        <div id={MOBILE_WRAPPER_ID}
             style={this.getWrapperStyles()}>
          <MobileRenderer
            staticMobileElements={staticMobileElements}
            mobileElements={mobileVisibleElements}
            desktopElements={desktopElements}
            staticDesktopElements={staticDesktopElements}
            showAds={this.shouldShowAds()}
            viewStyles={this.getViewStyles()}
            isPreviewMode={isPreviewMode}
            isQuickPreviewMode={isQuickPreviewMode}
          />
        </div>
      </div>
    );
  }
}

MobileView.propTypes = {
  isVisible: PropTypes.bool,
  isPreviewMode: PropTypes.bool
};